import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
/**
 * Renders the name of a conflicting ingredient in a recipe.
 * This component visually signifies that an ingredient is in conflict (e.g., due dietary restrictions or other reasons)
 * by striking through its name. It also conditionally appends a comma based on the `shouldAppendComma` prop.
 *
 * @param {string} ingredientName - The name of the ingredient that has a conflict.
 * @param {boolean} shouldAppendComma - Determines whether a comma should be appended after the ingredient name.
 */
export const ConflictingIngredient = ({ ingredientName, shouldAppendComma, inMainIngredientList, }) => {
    const theme = useTheme();
    const textColor = inMainIngredientList ? theme.palette.error.main : "inherit";
    const fontWeight = inMainIngredientList ? "bold" : "normal";
    const underline = inMainIngredientList ? "underline" : "line-through";
    return (_jsx(Typography, Object.assign({ variant: "body1", component: "span", sx: { textDecorationLine: underline, color: textColor, fontWeight: fontWeight } }, { children: ingredientName + (shouldAppendComma ? "" : ", ") })));
};
